/** Copyright ©2026 Devexperts LLC.
All rights reserved. Any unauthorized use will constitute an infringement of copyright.
In case of any questions regarding types of use, please contact legal@devexperts.com.
This notice must remain intact.
**/
/**
 * Creates mock implementation of {@link UserDataProvider}
 */
export function createMockUserDataProvider() {
    let userData = null;
    const updateUserData = (data) => {
        userData = data;
    };
    const getUserData = () => {
        return Promise.resolve(userData);
    };
    const setUserData = (userData) => {
        updateUserData(userData);
        return Promise.resolve(void 0);
    };
    return {
        setUserData,
        getUserData,
    };
}
